import type { MissionListItem } from '../lib/missionCategories'

import { MissionListItemCard } from './MissionListItemCard'

interface MissionClaimBannerProps {
  items: MissionListItem[]
  onSelect: (item: MissionListItem) => void
}

// Pinned block for missions that hit 100% but haven't had their reward
// claimed yet (MissionModal#handleClaimReward is a manual tap, not
// automatic) — sits below the filter row (chips + count/sort) but reads
// from unfiltered claimable items, so switching chips never hides or
// changes it. Only the header + border are custom; the cards themselves
// are the same MissionListItemCard used everywhere else in the list —
// a bespoke per-row design here was tried and was too cramped on mobile.
export function MissionClaimBanner({ items, onSelect }: MissionClaimBannerProps) {
  if (items.length === 0) return null

  const title = items.length === 1 ? 'Missão para Resgatar' : 'Missões para Resgatar'

  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-amber-200 bg-amber-50/70 p-2">
      <div className="flex justify-center">
        <span className="rounded-full bg-amber-100 px-3 py-0.5 font-hl text-xs font-bold tracking-wide text-amber-700 uppercase">
          ✦ {title} ✦
        </span>
      </div>
      {items.map(item => (
        <MissionListItemCard key={item.id} item={item} onClick={() => onSelect(item)} />
      ))}
    </div>
  )
}
